module.exports = __webpack_public_path__ + "img/14.371f3d60.png";